import { Controller } from "react-hook-form"
import DateField from "./date-field"
import { AdditionalFormFieldProps, TextFieldProps } from "../common-types"

export const DateFormField: React.FC<
  TextFieldProps & AdditionalFormFieldProps
> = (props) => {
  const { name, defaultValue, control } = props
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <DateField
          {...props}
          value={value}
          onChange={onChange}
          error={error}
        />
      )}
    />
  )
}

export default DateFormField
